import format from 'date-fns/format';
import locale from 'date-fns/locale/ru';

export function formatDate(
    date: Date | string,
    dateFormat: string = 'Do [de] MMMM YYYY'
): string {
    return format(date, dateFormat, { locale });
}
